'use client';

import ModalContainer from '../../components/ModalContainer';
import { useModalStore } from '../../hooks/store';
import { useDealId } from '../../providers/MetadataProvider';
import { ModuleProps, MultiStepModal } from './MultiStepWizard';

type MultiStepWizardContainerProps = {
  name: string;
  moduleName: string;
} & ModuleProps;

const renderModal =
  (props: MultiStepWizardContainerProps) =>
  (open: boolean, onClose: () => void) => {
    return (
      <MultiStepModal
        name={props.name}
        moduleName={props.moduleName}
        extraSteps={props.extraSteps}
        PlatformComponent={props.PlatformComponent}
        open={open}
        onSubmit={props.onSubmit}
        onClose={onClose}
      />
    );
  };

export const MultiStepWizardContainer = (
  props: MultiStepWizardContainerProps
) => {
  const fallbackId = useModalStore((state) => state.params?.dealId);
  const dealId = useDealId() || fallbackId;

  return (
    <ModalContainer
      name={props.name}
      renderModal={!dealId ? () => <div /> : renderModal(props)}
    />
  );
};
